import { getVariantOption } from '@/hooks/useProductVariant';

const slug = (value) => String(value).toLowerCase().replace(/[^a-z0-9]+/g, '-');

const ChoiceButton = ({ active, available, children, onClick, testId }) => (
  <button
    type="button"
    disabled={!available}
    onClick={onClick}
    data-testid={testId}
    className={`min-h-11 border px-3 py-2 font-mono2 text-[10px] uppercase transition-colors duration-200 disabled:cursor-not-allowed disabled:opacity-35 ${active ? 'border-[#1E1E1E] bg-[#1E1E1E] text-white' : 'border-[#D1D1D6] bg-white hover:border-[#8A9A86]'}`}
  >
    {children}
  </button>
);

const matchingVariant = (variants, optionName, value, colorName, colorValue) => (
  variants.find((variant) => getVariantOption(variant, optionName) === value && (!colorName || getVariantOption(variant, colorName) === colorValue) && variant.available)
  || variants.find((variant) => getVariantOption(variant, optionName) === value)
);

export function VariantPicker({ variants, colorOption, sizeOption, activeColor, activeSize, selected, onColorChange, onSizeChange, onVariantChange }) {
  return (
    <div className="mt-10 border-t border-[#D1D1D6] pt-7">
      <div className="mb-4 flex items-center justify-between">
        <p className="font-mono2 text-[10px] font-bold uppercase tracking-[0.22em]">Choose your piece</p>
        <p className="font-mono2 text-[9px] uppercase tracking-[0.18em] text-[#657260]" data-testid="selected-variant">{selected?.title}</p>
      </div>
      <div className="grid gap-7 sm:grid-cols-2" data-testid="variant-selector">
        {colorOption && <div data-testid="color-selector">
          <p className="mb-3 font-mono2 text-[9px] font-bold uppercase tracking-[0.2em] text-[#5C5C5C]">Color</p>
          <div className="flex flex-wrap gap-2">
            {colorOption.values.map((color) => {
              const variant = matchingVariant(variants, colorOption.name, color);
              return <ChoiceButton key={color} active={activeColor === color} available={variant?.available} onClick={() => onColorChange(color)} testId={`color-option-${slug(color)}`}>{color}</ChoiceButton>;
            })}
          </div>
        </div>}
        {sizeOption ? <div data-testid="size-selector">
          <p className="mb-3 font-mono2 text-[9px] font-bold uppercase tracking-[0.2em] text-[#5C5C5C]">Size</p>
          <div className="flex flex-wrap gap-2">
            {sizeOption.values.map((size) => {
              const variant = matchingVariant(variants, sizeOption.name, size, colorOption?.name, activeColor);
              return <ChoiceButton key={size} active={activeSize === size} available={variant?.available} onClick={() => onSizeChange(size)} testId={`size-option-${slug(size)}`}>{size}</ChoiceButton>;
            })}
          </div>
        </div> : <div className="flex flex-wrap gap-2">{variants.map((variant) => (
          <ChoiceButton key={variant.id || variant.title} active={selected?.title === variant.title} available={variant.available} onClick={() => onVariantChange(variant)} testId={`variant-option-${slug(variant.title)}`}>{variant.title}</ChoiceButton>
        ))}</div>}
      </div>
    </div>
  );
}